module.exports = __webpack_public_path__ + "static/media/Tsn_Malta.530b550d.png";